import * as React from 'react'

interface IMenuCloser {
  isOpen?: boolean
  closeMenu: () => void
  className?: string
  excludeId?: string
}

export default class MenuCloser extends React.Component<IMenuCloser> {
  public static defaultProps = {
    isOpen: true,
  }
  // "Inside" follows the React tree, so presses in portaled descendants
  // (popovers, sheets, menus) count. React's capture phase runs before this
  // document bubble listener, so the press is marked before it is judged.
  private insideTreeEvent: Event = null

  public render() {
    const { className, children } = this.props
    return (
      <div className={className} onMouseDownCapture={this.markInsideTree}>
        {children}
      </div>
    )
  }

  public componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  private markInsideTree = (event: React.MouseEvent) => {
    this.insideTreeEvent = event.nativeEvent
  }

  private handleClickOutside = (event: MouseEvent) => {
    const { closeMenu, isOpen, excludeId } = this.props
    const isInsideTree = event === this.insideTreeEvent
    this.insideTreeEvent = null

    if (
      isInsideTree ||
      !isOpen ||
      document.getElementById(excludeId)?.contains(event.target as Node)
    ) {
      return
    }

    event.stopPropagation()
    closeMenu()
  }
}
